import { useEntriesV2 } from "@/Hooks"
import { useEffect, useImperativeHandle } from "react"
import { useParams } from "react-router-dom"

export const useSubnetMappings = (ref) => {
	const { id } = useParams()
	const [directTunnelSubnetMapping, { getData: getDirectTunnelSubnetMapping }] = useEntriesV2(`/api/v2/device/directTunnel/${id}`)
	// const [_, { deleteData: deleteDirectTunneSubnetMappingById }] = useEntriesV2(`/api/v2/device/directTunnel/${id}/SubnetMapping`)

	useEffect(() => {
		getDirectTunnelSubnetMapping()
	}, [])

	useImperativeHandle(ref, () => ({
		getDirectTunnelSubnetMapping: getDirectTunnelSubnetMapping,
	}))

	return { getDirectTunnelSubnetMapping, directTunnelSubnetMapping }
}
